import { render, staticRenderFns } from "./ViewerAbstract.vue?vue&type=template&id=4aaf65f6&scoped=true&"
import script from "./ViewerAbstract.vue?vue&type=script&lang=js&"
export * from "./ViewerAbstract.vue?vue&type=script&lang=js&"
import style0 from "./ViewerAbstract.vue?vue&type=style&index=0&id=4aaf65f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf65f6",
  null
  
)

export default component.exports